module.exports = __webpack_public_path__ + "static/img/hetongBg.9f902ef8.png";